import React from "react";

function NotFound() {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "50px",
        backgroundColor: "#ffffff",   // ← white background
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <h1 style={{ fontSize: "80px", margin: "0", color: "#d9534f" }}>404</h1>
      <h2 style={{ margin: "10px 0", color: "#333" }}>Page Not Found</h2>
      <p style={{ color: "#666" }}>
        The page you are looking for does not exist.
      </p>
    </div>
  );
}

export default NotFound;
